export default function guest(state = {}, action) {
  if (action.type === 'RECEIVE_CHECKOUT_EMAIL') {
    return { email: action.payload }
  }

  return state
}
